export default "__VITE_PUBLIC_ASSET__c957d3c7__"